import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Utility from '../../../../util/utilityfunctions';
import {currentResource} from '../../../../util/utils';
import {colorOptions} from '../../../Pages/ContactDB/Toolbar/Tag/ManageTags/TagsList/utils/constants';

import OutputText from '@ey/canvascoreservices/OutputText';

import Chip from '../../../CoreWrappers/Chip';
import CountDropdownColumn from '../CountDropdownColumn';
import TagLabel from '../../TagLabel';

const TagsDropdownColumn = ({list}) => {
	if (list.length === 0) return false;

	const sortedList = Utility.sortListData(list, 'name');

	const customRender = (value, index, isFirst) => {
		const tagName =
			currentResource.tags.find((tag) => tag.id?.toLowerCase() === value?.key?.toLowerCase())?.name || value?.name;

		const variant = colorOptions.find((option) => option.value === value.color)?.chipVariant;

		const renderChip = () => {
			const props = {
				variant,
				type: 'outlined'
			};

			return (
				<Chip {...props}>
					<OutputText useTypography={false} ellipsis title={tagName}>
						{tagName}
					</OutputText>
				</Chip>
			);
		};

		const renderTag = () => {
			const props = {
				variant,
				text: tagName
			};

			return <TagLabel {...props} />;
		};

		return (
			<Fragment key={index}>
				{isFirst && renderChip()}
				{!isFirst && renderTag()}
			</Fragment>
		);
	};

	const props = {list: sortedList, customRender};

	return <CountDropdownColumn {...props} />;
};

TagsDropdownColumn.propTypes = {
	list: PropTypes.arrayOf(PropTypes.shape({}))
};

TagsDropdownColumn.defaultProps = {
	list: []
};

export default TagsDropdownColumn;
